import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { RuntimeService } from '../runtime.service'
import { Topic } from '../topic'
import { Project } from '../project'

@Component({
  selector: 'app-topic-summary',
  templateUrl: './topic-summary.component.html',
  styleUrls: ['./topic-summary.component.css']
})
export class TopicSummaryComponent implements OnInit {
  topic: Topic
  project: Project

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private rts: RuntimeService
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      let topicId = params['id']
      this.project = this.rts.currentProject
      if (!this.project)
        return
      this.topic = this.project.getTopic(topicId)
      if (!this.topic)
        return
    })
  }

  get topicDbRecords() {
    let ls = this.project.getTopicDbRecords(this.topic)
    return ls
  }

}



// WEBPACK FOOTER //
// ./src/app/topic-summary/topic-summary.component.ts